// ==========================================================================
// Alert Service - Alert API calls
// GET /api/user/alert
// ==========================================================================

import api from '@/lib/axios';
import type { Alert, GetAlertResponse } from '@/types/alert.types';

/**
 * Get the user's current active alert
 * Returns null if no active alert
 */
export async function getAlert(): Promise<Alert | null> {
  const response = await api.get<GetAlertResponse>('/user/alert');
  const alert = response.data.alert;
  if (alert && response.data.loan_offering) {
    alert.loan_offering = response.data.loan_offering;
  }
  return alert;
}
